import { Loader2 } from "lucide-react";
import { useState } from "react";
import { useCreateChangeReasonLog } from "../../api/drawingTool";
import { Button } from "../ui/common/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../ui/common/dialog";
import { Textarea } from "../ui/common/textarea";
import {
  mappingDialogBodyClass,
  mappingDialogContentClass,
  mappingDialogFooterClass,
  mappingDialogHeaderClass,
  mappingDialogLoadingOverlayClass
} from "../../screens/mapping_tool/mappingModalStyles";

const ChangeRequestModal = ({
  drawingId,
  sourceId,
  ownerId,
  mappingSourceType,
  closeModal = () => {},
  onSuccessEdit
}: any) => {
  const [reason, setReason] = useState<string>("");
  const [isError, setIsError] = useState(false);

  const { mutate, isLoading } = useCreateChangeReasonLog(mappingSourceType);

  const saveRequest = () => {
    const formattedReason = reason.trim();
    if (!formattedReason) {
      setIsError(true);
      return;
    }
    let changeRequest = {
      drawingId,
      reason: formattedReason,
      sourceId,
      ownerId,
      mappingType: mappingSourceType
    };
    mutate(changeRequest, {
      onSettled: () => {
        closeModal(true);
        onSuccessEdit();
      }
    });
  };

  return (
    <Dialog open onOpenChange={open => !open && closeModal()}>
      <DialogContent className={mappingDialogContentClass}>
        <DialogHeader className={mappingDialogHeaderClass}>
          <DialogTitle>Change Request</DialogTitle>
        </DialogHeader>

        <div className={mappingDialogBodyClass}>
          {isLoading ? (
            <div className={mappingDialogLoadingOverlayClass}>
              <Loader2 className="tw-h-6 tw-w-6 tw-animate-spin tw-text-primary" />
            </div>
          ) : null}

          <label className="tw-text-sm tw-font-medium tw-text-foreground">Reason</label>
          <Textarea
            value={reason}
            onChange={e => {
              setReason(e.target.value);
            }}
          />
          {isError ? (
            <p className="tw-m-0 tw-text-sm tw-text-destructive">
              Reason is required to submit a change request.
            </p>
          ) : null}
        </div>

        <DialogFooter className={mappingDialogFooterClass}>
          <Button type="button" variant="outline" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button type="button" onClick={() => saveRequest()}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeRequestModal;
